import React from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'
import { routePath, routeTo } from '@brainstud/react-helpers'
import { routes } from '../'
// TODO get appRoutes from provider
import { appRoutes } from '@brainstud/react-tbl/features'
import { Views } from './'

class IndexView extends React.Component {
  render() {
    return (
      <Switch>
        <Route path={routePath(routes, 'chapters')} exact render={() => <Redirect to={routeTo(appRoutes, 'home')} />} />
        <Route path={routePath(routes, 'quiz')}      component={Views.Quiz} />
        <Route path={routePath(routes, 'lesson')}    component={Views.Lesson} />
        <Route path={routePath(routes, 'chapter')}   component={Views.Chapter} />
      </Switch>
    )
  }
}

export default IndexView
